document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  forms.forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const formData = new FormData(form);
      await fetch('/cart/add.js', { method: 'POST', body: formData });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      document.querySelector('.cart-drawer')?.classList.add('is-active');
    });
  });
});
